import React, { useEffect, useState } from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import DataTable from "app/components/DataTable/DataTable";
import { useSelector } from "react-redux";
import { getMilestones } from "app/store/features/chartsSlice";
import { useDispatch } from "react-redux";
import FileUpload from "../compliance/FileUpload";
import { ColorsV2 } from "app/constants/color";
import { useTranslation } from "react-i18next";
import { GridActionsCellItem } from "@mui/x-data-grid";
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { Buttons } from "app/constants/sizing";
import { MilestoneModel } from "app/components";


const Documentation = () => {

    const dispatch = useDispatch();
    const milestoneData = useSelector(state => state.charts.milestones);

    const [fileModalOpen, setFileModalOpen] = useState(false);
    const [milestoneModalOpen, setMilestoneModalOpen] = useState(false);
    const [milestoneModalData, setMilestoneModalData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);

    const closeFileModal = () => setFileModalOpen(false);

    useEffect(() => {
        dispatch(getMilestones());
    }, [])

    const openFileModal = (row) => {
        setSelectedRow(row);
        setFileModalOpen(true);
    }

    const openMilestoneModal = (row) => {
        setMilestoneModalData([row]);
        setMilestoneModalOpen(true);
    }

    const addNewMilestone = () => {
        setMilestoneModalData([]);
        setMilestoneModalOpen(true);
    }

    const columns = [
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Manage',
            width: 110,
            getActions: (params) => [
                <GridActionsCellItem
                icon={<EditIcon />}
                label="Edit"
                onClick={() => openMilestoneModal(params?.row)}
                key="Edit"
                // showInMenu
                sx={{ ...Buttons.baseStyle.iconButton }}
                />
            ],
        },
        { 
            field: 'date', 
            headerName: 'Date', 
            type: 'date', 
            width: 130,
            // editable: true,
            filterable: true,
        },
        {
            field: 'name',
            headerName: 'Name',
            type: 'string', 
            width: 240,
            copyable: true,
            tooltip: true,
            // editable: true,
            filterable: true,
        },
        {
            field: 'description',
            headerName: 'Description',
            type: 'string', 
            width: 240,
            copyable: true,
            tooltip: true,
            filterable: true,
        },
        { field: 'locked', headerName: 'Locked', type: 'boolean', width: 70, filterable: false, },
        {
            field: 'files',
            headerName: 'Files',
            type: 'string', 
            sortable: false,
            width: 400,
            copyable: false,
            onClickMenu: true,
            menuCallback: openFileModal,
            tooltip: true,
            filterable: true,
            valueGetter: (params) =>
            (params.row?.files || []).map((file) => file.filename).join(', '),
            cellClassName: 'filesColumnCell',
        },
    ];

    const { t } = useTranslation('translation', {keyPrefix: 'insight_documentation'})
    
    return(
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            marginTop: '6%',
            padding: '20px',
        }}>
            <Typography variant='h4' sx={{ color: ColorsV2.white, marginBottom: '20px', }}>
                {t('page_heading')}
            </Typography>
            <Button
            variant='outlined'
            startIcon={<AddCircleOutlineOutlinedIcon />}
            onClick={addNewMilestone}
            sx={{...Buttons.baseStyle.primaryButtonLowPriority, width: '240px', marginY: '20px'}}
            >
                {t('add_new_milestone')}
            </Button>
            <Box sx={{ width: 'calc(100% - 44px)', border: '2px solid ' + ColorsV2.outline, }}>
                <DataTable 
                height='80vh' 
                width='100%' 
                rows={milestoneData} 
                columns={columns} 
                defaultSort={[{ field: 'date', sort: 'desc' }]} 
                allowSelection={false} 
                editMode={'row'} />
            </Box>
            <Modal open={fileModalOpen} onClose={closeFileModal}>
                <Box sx={{ 
                position: 'absolute', 
                top: '50%', 
                left: '50%', 
                transform: 'translate(-50%, -50%)', 
                backgroundColor: ColorsV2.primary, 
                padding: 2,
                border: '2px solid ' + ColorsV2.outline,
                borderRadius: '4px',
                }}>
                    <Typography variant='h6' sx={{color: ColorsV2.white}}>
                        {t('file_menu_header')}
                    </Typography>
                    <FileUpload
                    selectedFiles={[]}
                    setSelectedFiles={null}
                    previouslyAddedFiles={selectedRow?.files || []}
                    setPreviouslyAddedFiles={null}
                    setDeletedFiles={null}
                    >
                    </FileUpload>
                </Box>
            </Modal>
            {milestoneModalOpen && (
            <MilestoneModel
            setIsMilestoneModelOpen={setMilestoneModalOpen}
            fetchedMultipleMilestoneData={milestoneModalData}
            />
        )}
        </Box>
    )
}

export default Documentation;